import { render, staticRenderFns } from "./RelatedBestseller.vue?vue&type=template&id=3fe3f9e6&scoped=true&"
import script from "./RelatedBestseller.vue?vue&type=script&lang=js&"
export * from "./RelatedBestseller.vue?vue&type=script&lang=js&"
import style0 from "./RelatedBestseller.vue?vue&type=style&index=0&id=3fe3f9e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe3f9e6",
  null
  
)

export default component.exports